import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

const Loader = props => {
  if (props.loading) {
    return (
      <Box className='loader' sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <CircularProgress aria-label='Loading…' />
      </Box>
    )
  } else {
    return props.children
  }
}

export default Loader
